
    import Component from "vue-class-component";
    import Vue from "vue";
    import CutieCardImagePart from "@/app/components/cutie/cards/CutieCardImagePart.vue";
    import CutieCardStats from "@/app/components/cutie/cards/CutieCardStats.vue";
    import CutieCardMetaDetailsLine from "@/app/components/cutie/cards/CutieCardMetaDetailsLine.vue";
    import CutieCardNameLine from "@/app/components/cutie/cards/CutieCardNameLine.vue";
    import { Emit, Prop, PropSync } from "vue-property-decorator";
    import type { CutieListEntryMinimalView } from "cuties-client-components/types/api/Cutie";
    import type { QuickSlotItem } from "@/cuties/pet/PetService";
    import { Getter } from "vuex-class";
    import { AppStoreGetters } from "@/store/AppStore";

    @Component({
        components: { CutieCardImagePart, CutieCardStats, CutieCardMetaDetailsLine, CutieCardNameLine }
    })
    export default class CutieCardWithControls extends Vue {
        @Prop({ required: true }) cutie!: CutieListEntryMinimalView;
        @Prop({ required: true }) showStats!: boolean;
        @Prop({ required: true }) controls!: boolean;
        @Prop({ required: false }) quickSlotItems?: QuickSlotItem[];
        @PropSync("markedWithCheckbox", { required: true }) syncedMarkedWithCheckbox!: boolean;
        @PropSync("healedFromAdventureByItem", { required: true }) syncedHealedFromAdventureByItem!: boolean;
        @Prop({ default: false }) disableTooltips!: boolean;
        @Getter(AppStoreGetters.GET_EVERY_SECOND_TICK_TIME_MS) everySecondTickTimeMs: number;

        adventureCooldownTierOffset = 0;

        mounted() {
            this.adventureCooldownTierOffset = 0;
            this.syncedHealedFromAdventureByItem = false;
        }

        get ts() {
            return Math.ceil(this.everySecondTickTimeMs / 1000);
        }

        get isHealingFromAdventure(): boolean {
            return !this.isBorn
                || this.cutie.timeNextAdventure >= this.ts
                && !this.syncedHealedFromAdventureByItem;
        }

        get isBorn(): boolean {
            return this.cutie?.timeBorn < this.ts;
        }

        get effectiveCutie(): CutieListEntryMinimalView {
            const adventureCooldown =
                this.cutie.adventureCooldown +
                this.adventureCooldownTierOffset;
            const timeNextAdventure = this.syncedHealedFromAdventureByItem
                ? Math.floor(Date.now() / 1000)
                : this.cutie.timeNextAdventure;
            return { ...this.cutie, adventureCooldown, timeNextAdventure };
        }

        @Emit("imageClick")
        imageClick() {}
    }
